
// region JS Imports

// region External Modules
// endregion External Modules

// region Private Modules
// endregion Private Modules

// region Public Components
import {
  InputSelector as BaseInputSelector,
  JSSelectPicker,
  Selector as BaseSelector,
} from "components/js_selectpicker/base"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


type Selector = BaseSelector & {
  container: string
}

type InputSelector = BaseInputSelector & {
  container?: string
}

const default_selector = {
  scope:        ".page-section--children-buildings-section--table--phase-building-select-container",
  main:         ".page-section--children-buildings-section--table--phase-building-select",
  arrow:        ".select2-selection__arrow b[role=\"presentation\"]",
  first_option: "option:nth-of-type(1)",
  container:    ".select2-container",
}


class PhaseBuildingSelector extends JSSelectPicker {
  protected selector: Selector

  protected $container: JQuery

  constructor(selector?: InputSelector) {
    const merged_selector = Object.assign({}, default_selector, selector)

    super(merged_selector)

    if (this.$scope.length === 0){
      throw new Error("this.$scope absent")
    }

    this.selector = merged_selector

    this.$container = this.$scope.find(this.selector.container)
  }

  protected bind_action() {
    this.$el.on("select2:select", () => {
      this.emit("val_change")
    })
  }

  public selected_option() {
    return this.$el.val()
  }
}


const Factory = {
  _instance: null as null | PhaseBuildingSelector,
  instance(selector?: InputSelector): PhaseBuildingSelector {
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)

    return this._instance
  },
  create(selector?: InputSelector): PhaseBuildingSelector {
    return new PhaseBuildingSelector(selector)
  },
}

export {
  Factory,
  PhaseBuildingSelector,
}
